import React, { useEffect } from "react";
import { SplashScreenView, useApp } from "../contexts";

export const Logout = () => {
  const { logout } = useApp();
  useEffect(() => {
    logout();
  }, []);
  return <SplashScreenView />;
};
